"use client";

export type GardenType = "container" | "outdoor";

interface Props {
  value: GardenType;
  onChange: (t: GardenType) => void;
}

const OPTIONS: { value: GardenType; label: string }[] = [
  { value: "outdoor", label: "Outdoor Garden" },
  { value: "container", label: "Container Garden" },
];

/**
 * Outdoor / Container switch at the top of both Designer flows. Shown only to
 * a garden center with the CONTAINER_GARDEN add-on (see lib/container/access).
 */
export function GardenTypeToggle({ value, onChange }: Props) {
  return (
    <div className="flex justify-center">
      <div
        role="tablist"
        aria-label="Garden type"
        className="inline-flex rounded-xl bg-[#e3ebe5] p-1 dark:bg-plantista-800"
      >
        {OPTIONS.map((o) => {
          const active = o.value === value;
          return (
            <button
              key={o.value}
              type="button"
              role="tab"
              aria-selected={active}
              onClick={() => !active && onChange(o.value)}
              className={`rounded-lg px-4 py-1.5 text-sm font-medium transition-colors ${
                active
                  ? "bg-white text-[#0f2a1d] shadow-sm dark:bg-plantista-950 dark:text-plantista-50"
                  : "text-[#4b5d52] hover:text-[#0f2a1d] dark:text-plantista-300"
              }`}
            >
              {o.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}
